import { Bot } from "./bot";

export class ActionRow {
  public id: string;
  public jsonDeterminants: string = "";
  public bots: Bot[] = [];
  public sortOrderNumber: number;
  public parallel: boolean = false;
  public mandatory: boolean = false;
  public multipleBot: boolean = false;
  public multipleFieldKey: string;
  public targetTabComponentKey: string = null;
  public targetElementKey: string = null;
  // TOBE-17942 goToTab: key of the destination tab PANE this action navigates to.
  // Separate from targetTabComponentKey (container-as-context for next/prev/validate).
  public destinationTabKey: string = null;
  // Media Manager (#95): selectedMediaFileId is the system-action equivalent of
  // targetElementKey — set when this action's intent is "download a media file".
  // selectedMediaFileName is denormalised so the picker chip can render without
  // an extra round-trip; the runtime resolves files by id.
  public selectedMediaFileId: string = null;
  public selectedMediaFileName: string = null;
}
